// Which zipInfo entries belong to the streaming pipeline (manifest, tiles,
// fragments, library GLBs) rather than being a document's record files.
// Mirrors the C# IsStreamingPipelineFile classifier in R2FileUploadUtility;
// the two MUST stay in sync. Was local to pages/ModelViewer, where its
// history is; shared since 2026-10-29 with Find in Sheets & Model.
export function isStreamingPipelineEntry(name) {
  if (!name) return false;

  // Strip a leading "/" if present and lowercase for case-insensitive
  // matching. Path separators in pathsmapping are forward slashes
  // (Unix-style) by R2FileUploadUtility convention.
  const lower = String(name).replace(/^\/+/, "").toLowerCase();

  // Manifest at the root.
  if (lower === "manifest.json" || lower === "manifest.json.gz") return true;

  // Tiles directory.
  if (lower.startsWith("tiles/")) return true;

  // Fragments directory.
  if (lower.startsWith("fragments/")) return true;

  // Library GLBs at the root (library.fine.glb, library.coarse.glb, ...).
  if (
    (lower.startsWith("library.") &&
      (lower.endsWith(".glb") || lower.endsWith(".glb.gz")))
  ) {
    return true;
  }

  return false;
}
